<template>
  <div>
    <!--Header-->
    <div class="header bg-success pt-5 pb-7">
      <div class="container">
        <div class="header-body">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="pr-5">
                <h1 class="display-2 text-white font-weight-bold mb-0">Fusion Pro</h1>
                <h2 class="display-4 text-white font-weight-light">Most Innovative Institute Management Software</h2>
                <p class="text-white mt-4">Fusion is school management app designed for this era. It provides prowerful apps to parents, students & teachers to always stay updated with daily progress and studies!</p>
                <div class="mt-5">                  
                  <a href="https://play.google.com/store/apps/details?id=fusion.fastech.pk&hl=en_US" target="_blank" class="btn btn-neutral my-2">Get our app</a>
                  <a href="https://wa.me/923122828038" class="btn btn-default my-2">Request Demo</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row pt-5">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <div class="icon icon-shape bg-gradient-red text-white rounded-circle shadow mb-4">
                        <i class="ni ni-hat-3"></i>
                      </div>
                      <h5 class="h3">Live Classes</h5>
                      <p>Conduct live classes and upload recordings for students</p>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <div class="icon icon-shape bg-gradient-info text-white rounded-circle shadow mb-4">
                        <i class="ni ni-check-bold"></i>
                      </div>                     
                       <h5 class="h3">Recorded Lectures</h5>
                      <p>You can now upload pre-recorded lectures on Fusion so the student can learn at their pace.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 pt-lg-5 pt-4">
                  <div class="card mb-4">
                    <div class="card-body">
                      <div class="icon icon-shape bg-gradient-success text-white rounded-circle shadow mb-4">
                        <i class="ni ni-like-2"></i>
                      </div>
                      <h5 class="h3">Adaptability</h5>
                      <p>The needs of schools are constantly changing, so you need a system that is adaptable to meet future needs.</p>
                    </div>
                  </div>
                  <div class="card mb-4">
                    <div class="card-body">
                      <div class="icon icon-shape bg-gradient-warning text-white rounded-circle shadow mb-4">
                        <i class="ni ni-cloud-upload-96"></i>
                      </div>
                      <h5 class="h3">So much more!</h5>
                      <p>Post assignments, take quizzes, send multimedia messages, deliver fee challan on parents WhatsApp and many more amazing features.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <section class="py-6 pb-9 bg-default">
      <div class="row justify-content-center text-center">
        <div class="col-md-6">
          <h2 class="display-3 text-white">State of the art Solution!</h2>
          <p class="lead text-white">
          
          </p>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 mt--7">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-4">
                <div class="card card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div class="icon icon-shape bg-gradient-primary text-white rounded-circle mb-4">
                      <i class="ni ni-check-bold"></i>
                    </div>
                    <h4 class="h3 text-primary text-uppercase">Admin Portal</h4>
                    <p class="description mt-3">A comprehensive administrative solution for your institute's needs.</p>
                    <div>
                       <span class="badge badge-pill badge-primary">Fee Management</span>
                        <span class="badge badge-pill badge-primary" style="margin-left:5px;">SMS &#38; Notifications</span>
                        <span class="badge badge-pill badge-primary" >HR &#38; Payroll</span>
                        <span class="badge badge-pill badge-primary" style="margin-left:5px;">Accounts Management</span>
                      
                     
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="card card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div class="icon icon-shape bg-gradient-default text-white rounded-circle mb-4">
                      <i class="ni ni-circle-08"></i>
                    </div>
                    <h4 class="h3 text-default text-uppercase">Parents App</h4>
                    <p class="description mt-3">Fusion provides a modern app for parents to stay updated with their children progress.</p>
                    <div>
                      <span class="badge badge-pill badge-default">Live Class</span>
                      <span class="badge badge-pill badge-default" style="margin-left:5px;">Lectures</span>
                      <span class="badge badge-pill badge-default"  style="margin-left:5px;">Homework</span>
                      <span class="badge badge-pill badge-default">Notifications</span>
                      <span class="badge badge-pill badge-default"  style="margin-left:5px;">Fee Challan</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="card card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div class="icon icon-shape bg-gradient-danger text-white rounded-circle mb-4">
                      <i class="ni ni-hat-3"></i>
                    </div>
                    <h4 class="h3 text-warning text-uppercase">Teachers App</h4>
                    <p class="description mt-3">Packed with the most required features. Manage your classes at your fingertip.</p>
                    <div>
                      <span class="badge badge-pill badge-warning">Upload Lectures</span>
                      <span class="badge badge-pill badge-warning" style="margin-left:5px;">Assignments</span>
                      <span class="badge badge-pill badge-warning">Take Attendance</span>
                      <span class="badge badge-pill badge-warning" style="margin-left:5px;">Examination Marks</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="py-6">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img src="img/theme/landing-1.png" class="img-fluid">
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <h1>Awesome features</h1>
              <p>Our dashboard comes with super cool features that are meant to provide insightful reports. Our Handcrafted components are super responsive that works on all devices.</p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="badge badge-circle badge-success mr-3">
                        <i class="ni ni-settings-gear-65"></i>
                      </div>
                    </div>
                    <div>
                      <h4 class="mb-0">Upload Lectures &#38; Assignment</h4>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="badge badge-circle badge-success mr-3">
                        <i class="ni ni-email-83"></i>
                      </div>
                    </div>
                    <div>
                      <h4 class="mb-0">Send Push Notifications in Real-time</h4>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="badge badge-circle badge-success mr-3">
                        <i class="ni ni-satisfied"></i>
                      </div>
                    </div>
                    <div>
                      <h4 class="mb-0">Super friendly support team</h4>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="py-6">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <img src="img/theme/landing-2.png" class="img-fluid">
          </div>
          <div class="col-md-6">
            <div class="pr-md-5">
              <h1>Parent App</h1>
              <p>Education does not have to stop due to COVID. Parent, students and teachers can now stay connected no matter where they are.</p>
              <a href="https://play.google.com/store/apps/details?id=fusion.fastech.pk&hl=en_US" target="_blank" class="btn btn-default my-2">Download app</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="py-6">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img src="img/theme/landing-3.png" class="img-fluid">
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <h1>Teachers App</h1>
              <p>Now teachers can manage their classes directly from their smartphones.</p>
                <a href="https://wa.me/923122828038" class="btn btn-default my-2">Request Demo</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section hidden class="py-7 section-nucleo-icons bg-white overflow-hidden">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">Nucleo Icons</h2>
            <p class="lead">
              The official package contains over 21.000 icons which are looking great in combination with Argon Design System. Make sure you check all of them and use those that you like the most.
            </p>
            <div class="btn-wrapper">
              <a href="https://demos.creative-tim.com/vue-argon-dashboard-pro/documentation/foundation/icons.html" class="btn btn-primary">View demo icons</a>
              <a href="https://nucleoapp.com/?ref=1712" target="_blank" class="btn btn-default mt-3 mt-md-0">View all icons</a>
            </div>
          </div>
        </div>
        <div class="blur--hover">
          <a href="https://demos.creative-tim.com/vue-argon-dashboard-pro/documentation/foundation/icons.html">
            <div class="icons-container blur-item mt-5">
              <!-- Center -->
              <i class="icon ni ni-diamond"></i>
              <!-- Right 1 -->
              <i class="icon icon-sm ni ni-album-2"></i>
              <i class="icon icon-sm ni ni-app"></i>
              <i class="icon icon-sm ni ni-atom"></i>
              <!-- Right 2 -->
              <i class="icon ni ni-bag-17"></i>
              <i class="icon ni ni-bell-55"></i>
              <i class="icon ni ni-credit-card"></i>
              <!-- Left 1 -->
              <i class="icon icon-sm ni ni-briefcase-24"></i>
              <i class="icon icon-sm ni ni-building"></i>
              <i class="icon icon-sm ni ni-button-play"></i>
              <!-- Left 2 -->
              <i class="icon ni ni-calendar-grid-58"></i>
              <i class="icon ni ni-camera-compact"></i>
              <i class="icon ni ni-chart-bar-32"></i>
            </div>
            <span class="blur-hidden h5 text-success">Eplore all the 21.000+ Nucleo Icons</span>
          </a>
        </div>
      </div>
    </section>
    <section hidden class="py-7">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">Do you love this awesome <span class="text-success">Dashboard for Bootstrap 4?</span></h2>
            <p class="lead">Cause if you do, it can be yours now. Hit the button below to navigate to get the free version or purchase a license for your next project. Build a new web app or give an old Bootstrap project a new look!</p>
            <div class="btn-wrapper">
              <a href="https://www.creative-tim.com/product/vue-argon-dashboard?ref=vadp-index-page" class="btn btn-neutral mb-3 mb-sm-0" target="_blank">
                <span class="btn-inner--text">Get FREE version</span>
              </a>
              <a href="https://www.creative-tim.com/product/vue-argon-dashboard-pro?ref=vadp-index-page" class="btn btn-success btn-icon mb-3 mb-sm-0">
                <span class="btn-inner--icon"><i class="ni ni-basket"></i></span>
                <span class="btn-inner--text">Purchase now</span>
                <span class="badge badge-md badge-pill badge-floating badge-danger border-white">$89</span>
              </a>
            </div>
            <div class="text-center">
              <h4 class="display-4 mb-5 mt-5">Available on these technologies</h4>
              <div class="row justify-content-center">
                <div class="col-md-2 col-3 my-2">
                  <el-tooltip placement="top" content="Bootstrap 4 - Most popular front-end component library">
                    <a href="https://www.creative-tim.com/product/argon-dashboard?ref=vadp-index-page" target="_blank">
                      <img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/bootstrap.jpg" class="img-fluid rounded-circle shadow shadow-lg--hover">
                    </a>
                  </el-tooltip>
                </div>
                <div class="col-md-2 col-3 my-2">
                  <el-tooltip placement="top" content="Vue.js - The progressive javascript framework">
                    <a href="https://www.creative-tim.com/product/vue-argon-dashboard?ref=vadp-index-page" target="_blank">
                      <img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/vue.jpg" class="img-fluid rounded-circle">
                    </a>
                  </el-tooltip>
                </div>
                <div class="col-md-2 col-3 my-2">
                  <el-tooltip placement="top" content="[Coming Soon] Sketch - Digital design toolkit">
                    <a href=" https://www.sketchapp.com/" target="_blank">
                      <img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/sketch.jpg" class="img-fluid rounded-circle opacity-3">
                    </a>
                  </el-tooltip>
                </div>
                <div class="col-md-2 col-3 my-2">
                  <el-tooltip placement="top" content="[Coming Soon] Adobe Photoshop - Software for digital images manipulation">
                    <a href=" https://www.adobe.com/products/photoshop.html" target="_blank">
                      <img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/ps.jpg" class="img-fluid rounded-circle opacity-3">
                    </a>
                  </el-tooltip>
                </div>
                <div class="col-md-2 col-3 my-2">
                  <el-tooltip placement="top" content="Angular - One framework. Mobile ">
                    <a href="https://www.creative-tim.com/product/argon-dashboard-angular?ref=vadp-index-page" target="_blank">
                      <img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/angular.jpg" class="img-fluid rounded-circle opacity-3">
                    </a>
                  </el-tooltip>
                </div>
                <div class="col-md-2 col-3 my-2">
                  <el-tooltip placement="top" content="React - A JavaScript library for building user interfaces">
                    <a href="https://www.creative-tim.com/product/argon-dashboard-react?ref=vadp-index-page" target="_blank">
                      <img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/react.jpg" class="img-fluid rounded-circle">
                    </a>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>``
<script>
  import { Tooltip } from 'element-ui'
  export default {
    name: 'home-page',
    components: {
      [Tooltip.name]: Tooltip
    }
  };
</script>
